import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "tag-left-arrow"
}
const _hoisted_2 = { class: "tag__title" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "icon" }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "tag-right-arrow"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      'tag',
      `tag--${_ctx.filter.type}`,
      {'tag--with-right-arrow': _ctx.isRightArrow},
      {'subtag': _ctx.isSubTag},
      {'subtag--is-last-child': _ctx.isSubTag && _ctx.isLastChild},
      {'subtag--is-active': _ctx.isActive},
      'no-select',
    ]),
    style: _normalizeStyle(`${_ctx.filter.color ? `--tag-color: #${_ctx.filter.color}` : ''}`),
    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.selectSub && _ctx.selectSub(...args)))
  }, [
    (_ctx.isLeftArrow)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass([
        'content',
        {'content--without-right-border-radius': _ctx.isRightArrow},
        {'content--without-left-border-radius': _ctx.isLeftArrow},
        {'content--without-right-padding': _ctx.isRightArrow},
        {'content--small-right-padding': _ctx.isRightArrow && _ctx.isSubTag},
      ])
    }, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.filter.name), 1),
      (!_ctx.isSubTag)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "tag__delete",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('deselect', _ctx.filter.id, _ctx.filter.type)))
          }, _hoisted_4))
        : _createCommentVNode("", true)
    ], 2),
    (_ctx.isRightArrow)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5))
      : _createCommentVNode("", true)
  ], 6))
}